/* eslint-disable */
import {
  Box,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import Add from "views/admin/events/components/Add";
import React, { useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { getImageUrl } from "Api/apiService";
import { createMerch, updateMerch, deleteMerch } from "Api/apiService";
import MerchDetailModal from "./MerchDetailModal";
import AddMerchItemDetailModal from "./AddMerchItemDetailModal";

export default function MerchTable(props) {
  const { columnsData, tableData } = props;
  const [selectedMerch, setSelectedMerch] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
    setGlobalFilter,
  } = tableInstance;
  initialState.pageSize = 100;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );

  const handleRowClick = (item) => {
    setSelectedMerch(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedMerch(null);
    setIsModalOpen(false);
  };
  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const handleCreate = async (itemName, itemPrice, itemImage) => {
    try {
      await createMerch(itemName, itemPrice, itemImage);
    } catch (error) {
      console.error("Error creating merch item:", error);
    }
  };

  const handleUpdate = async (merchId, itemName, itemPrice, itemImage) => {
    try {
      await updateMerch(merchId, itemName, itemPrice, itemImage);
    } catch (error) {
      console.error("Error updating merch item:", error);
    }
  };

  const handleDelete = async (merchId) => {
    try {
      await deleteMerch(merchId);
    } catch (error) {
      console.error("Error deleting merch item:", error);
    }
  };

  return (
    <Card direction="column" w="100%" px="0px">
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="26px"
          fontWeight="700"
          lineHeight="100%"
          textAlign="center"
          flex={1}
        >
          All Merch Items
        </Text>
        <Add onClick={() => setIsAddModalOpen(true)} />
      </Flex>
      <Box px="25px" mb="16px">
        <Input
          placeholder="Search merch items"
          value={searchValue}
          onChange={(event) => {
            const nextValue = event.target.value;
            setSearchValue(nextValue);
            setGlobalFilter(nextValue || undefined);
          }}
        />
      </Box>
      <Box
        overflowY="auto"
        maxHeight="750px"
        css={{
          "&::-webkit-scrollbar": {
            width: "5px",
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              const merch = row.original;
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  onClick={() => handleRowClick(merch)}
                  cursor="pointer"
                  _hover={bgHover}
                >
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "Name") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "Price") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          ${cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "Image") {
                      data = (
                        <Image
                          h="80px"
                          w="80px"
                          src={getImageUrl(cell.value)}
                          borderRadius="8px"
                          me="20px"
                        />
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor={borderColor}
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
      <MerchDetailModal
        isOpen={isModalOpen}
        onClose={closeModal}
        selectedMerch={selectedMerch}
        onUpdateMerch={handleUpdate}
        onDeleteMerch={handleDelete}
      />
      <AddMerchItemDetailModal
        isOpen={isAddModalOpen}
        onClose={closeAddModal}
        createMerch={handleCreate}
      />
    </Card>
  );
}
